import React from 'react';
import HarrisPaginationNPM from '@rotaryintl/harris-pagination';

const HarrisPagination = ({ totalCount, siblingCount = 1, currentPage = 1, pageSize = 10, lang = 'en', onPageChange }) => {
  const handlePageChange = (event, newPage) => {
    if (onPageChange && Number.isInteger(newPage)) {
      onPageChange(newPage);
    }
  };

  return (
    <HarrisPaginationNPM
      totalCount={totalCount}
      siblingCount={siblingCount}
      currentPage={currentPage}
      pageSize={pageSize}
      lang={lang}
      onPageChange={handlePageChange}
    />
  );
};

export default HarrisPagination;
